import React from 'react';

export default function Terms() {
  return (
    <section className="pt-28 pb-32 px-4 text-white bg-[#060b29] min-h-screen">
      <div className="max-w-4xl mx-auto text-center">
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-30">Terms and Conditions</h1>

        {/* Section 1 */}
        <div className="mb-20 text-left">
          <h2 className="text-purple-300 mb-4" style={{ fontSize: '28px' }}>1. Use of Services</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-300" style={{ fontSize: '20px' }}>
            <li><strong>Eligibility:</strong> You must be at least 18 years old and legally allowed to use financial services.</li>
            <li><strong>Registration:</strong> You agree to provide accurate, up-to-date information when creating an account.</li>
            <li><strong>License:</strong> We grant you a limited, non-exclusive license to use our services for personal or business purposes.</li>
          </ul>
        </div>

        {/* Section 2 */}
        <div className="mb-20 text-left">
          <h2 className="text-purple-300 mb-4" style={{ fontSize: '28px' }}>2. Disclaimer and Risk Warning</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-300" style={{ fontSize: '20px' }}>
            <li><strong>No Financial Advice:</strong> PipPlus Tech does not provide any kind of investment or financial advice. Users are solely responsible for their own trading decisions.</li>
            <li><strong>High Risk:</strong> Trading in forex involves a high level of risk. You may lose some or all of your investment.</li>
            <li><strong>Past Performance:</strong> Historical trading results do not guarantee future performance.</li>
          </ul>
        </div>

        {/* Section 3 */}
        <div className="text-left">
          <h2 className="text-purple-300 mb-4" style={{ fontSize: '28px' }}>3. Intellectual Property</h2>
          <p className="text-gray-300 leading-relaxed" style={{ fontSize: '20px' }}>
            All content, algorithms, and tools on this platform are the property of PipPlus Tech.
            You are not allowed to copy, share, or sell them without permission.
          </p>
        </div>
      </div>
    </section>
  );
}
